import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { ILifeTestLog } from 'src/app/user-identification/models/life-check';
import {
	TAudioLogs,
	TConsoleLogs,
	TConnectionLogs,
	TDocsLogs,
	THomeLogs,
	TOcrLogs,
	TPolLogs,
	TProcessLogs,
} from 'src/app/user-identification/models/user-identification';
import { environment } from 'src/environments/environment';

type TLogInfo =
	| TPolLogs
	| TOcrLogs
	| TDocsLogs
	| TProcessLogs
	| TConnectionLogs
	| THomeLogs
	| TConsoleLogs
	| TAudioLogs
	| string;

export enum LogType {
	Emergency = 'emergency',
	Alert = 'alert',
	Critical = 'critical',
	Error = 'error',
	Warning = 'warning',
	Notice = 'notice',
	Info = 'info',
	Debug = 'debug',
}

@Injectable({
	providedIn: 'root',
})
export class CloudLogsService extends ApiService {
	private processUUID: string = '';
	private deviceId: string = '';
	private deviceType: 'primary' | 'secondary' | string = '';

	constructor() {
		super();
	}

	public sendCloudLogs(data: any, info: TLogInfo, type: LogType, image?: string): void {
		this.http
			.post<any>(environment.identity2 + `/log`, this.getBodyLog(data, info, type, image), {
				headers: this.getHeaders(),
			})
			.subscribe({
				next: () => {},
				error: () => {},
				complete: () => {},
			});
	}

	private getBodyLog(data: any, info: TLogInfo, type: LogType = LogType.Debug, image?: string): ILifeTestLog {
		// Añadir process UUID al payload
		let payloadData: any;
		if (data && typeof data === 'object' && !Array.isArray(data)) {
			payloadData = { ...data, process: this.getProcessUUID() };
		} else {
			payloadData = { message: data, process: this.getProcessUUID() };
		}

		return {
			method: this.getMethod(info),
			type: type,
			info: info,
			data: JSON.stringify(payloadData),
			op_uuid: this.getProcessUUID(),
			image: image,
			deviceId: this.deviceId,
			deviceType: this.deviceType,
		};
	}

	private getMethod(info: TLogInfo): string {
		if (info.includes('PoL -')) {
			return 'PoL';
		}
		if (info.includes('OCR -')) {
			return 'OCR';
		}
		if (info.includes('Docs -')) {
			return 'Docs';
		}
		if (info.includes('Connection - ')) {
			return 'Connection';
		}
		if (info.includes('Process -')) {
			return 'Process';
		}
		if (info.includes('Home -')) {
			return 'Home';
		}
		if (info.includes('Master -')) {
			return 'Master';
		}
		if (info.includes('Auth -')) {
			return 'Auth';
		}
		if (info.includes('Console -')) {
			return 'Console';
		}
		if (info.includes('Audio -')) {
			return 'Audio';
		}
		return info as string;
	}

	public getProcessUUID(): string {
		return this.processUUID;
	}

	public setProcessUUID(value: string): void {
		this.processUUID = value;
	}

	public getDeviceId(): string {
		return this.deviceId;
	}

	public setDeviceId(value: string): void {
		this.deviceId = value;
	}

	public getDeviceType(): 'primary' | 'secondary' | string {
		return this.deviceType;
	}

	public setDeviceType(value: 'primary' | 'secondary'): void {
		this.deviceType = value;
	}
}
